import React from "react"

const WOFormContext = React.createContext()

export default WOFormContext
